import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
// import { Search } from 'lucide-react';
import { Button } from '../../Common/Button';
import AddBulkAgents from '../../Commponent/AddBulkAgents';
import AddAgent, { AgentDetails } from '../../Commponent/AddAgent';
import TextInput from '../../Commponent/TextInput';
import CustomSelectInput from '../../Commponent/SelectInput';
import edit from './../../assets/edit.png';
import { Search } from 'lucide-react';
import { vehicleClasses } from '../../Utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast } from '../../Utils/toast';
import CommonTable from '../../Common/CommonTable';
import SideModal from '../../Commponent/SideModal';
import DistributorAgentsModal from '../../Commponent/DistributorAgentsModal';
import DistributorDealersModal from '../../Commponent/DistributorDealersModal';


// import AgentDetails from './../Commponent/AgentDetails';

//DISTRIBUTOR admin
const DistributorAdmin = () => {
  const dispatch = useDispatch();
  const GetDistributor = useSelector((state) => state.GetDistributor.GetDistributorData);
  const GetAgentsDistributorWise = useSelector((state) => state.GetAgentsDistributorWise.GetAgentsDistributorWiseData);
  const GetDistributorNames = useSelector((state) => state.GetDistributorNames.GetDistributorNamesData);
  const EditDistributor = useSelector((state) => state.EditDistributor.EditDistributorData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [serialNumber, setSerialNumber] = useState('');
  const [selectedAgent, setSelectedAgent] = useState('');
  const [editingDistributor, setEditingDistributor] = useState(null);
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedAgentClick, setSelectedAgentClick] = useState(false);
  const [agentModalOpen, setAgentModalOpen] = useState(false);
  const [checkAgents, setCheckAgents] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [checkAgentsName, setCheckAgentsName] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [sortOrder, setSortOrder] = useState(null); // For status sorting
  const [assigningDistributor, setAssigningDistributor] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [distributorData, setDistributorData] = useState([]);
  const [distributorDataNames, setDistributorDataNames] = useState([]);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [showAgentsModal, setShowAgentsModal] = useState(false);
  const [selectedDistributorForAgents, setSelectedDistributorForAgents] = useState(null);
  const [showDealersModal, setShowDealersModal] = useState(false);
  const [selectedDistributorForDealers, setSelectedDistributorForDealers] = useState(null);

  const columns = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
  ];


  const columns1 = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
    { label: 'Delivery Date', accessor: 'DeliveryDate' },
    { label: 'Delivery Status', accessor: 'DeliveryStatus' },
  ];

  const data = [
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC4",
      Status: "Unassigned",
      PurchaseDate: "3 March, 2025",
      AssignedTo: "5 March, 2025",
      vehicleClass: 6,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC5",
      Status: "Unassigned",
      PurchaseDate: "30 March, 2025",
      AssignedTo: "1 March, 2025",
      vehicleClass: 5,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC6",
      Status: "Unassigned",
      PurchaseDate: "1 March, 2025",
      AssignedTo: "30 March, 2025",
      vehicleClass: 4,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    }
  ]

  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  const paginatedData = tableData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const summaryData = [
    { name: 'Vikas', percent: 81, label: 'Most Active', color: '#22c55e' },
    { name: 'Karishma', percent: 70, label: 'Least Active', color: '#ef4444' },
  ];

  // Initial mount — fetch names dropdown + table data ONCE
  useEffect(() => {
    setCheckAgentsName(true);
    dispatch(ACTIONS.GetDistributorNamesAction());
    getData();
  }, []);

  // Re-fetch table data when filters/pagination change (skip initial mount)
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    getData();
  }, [serialNumber, selectedAgent, currentPage, itemsPerPage, refreshCount]);



  const handleAgentClick = (agentName) => {
    setSelectedAgentClick(agentName);
    setAgentModalOpen(true);
  };

  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      search: serialNumber,
      username: selectedAgent
    }
    setCheckAgents(true)
    dispatch(ACTIONS.GetDistributorAction(params));
  }



  useEffect(() => {
    if (checkAgents) {
      if (GetDistributor?.status == 200 && GetDistributor?.success) {
        setDistributorData(GetDistributor?.data.data);
      } else if (GetDistributor) {
        ErrorToast(GetDistributor?.message);
      }
      setCheckAgents(false)
    }
  }, [GetDistributor])

  useEffect(() => {
    if (checkAgentsName) {

      if (GetDistributorNames?.status == 200 && GetDistributorNames?.success) {
        const uniqueAgents = Array.from(
          new Map(
            GetDistributorNames?.data?.map((agent) => [agent.username, agent])
          ).values()
        );

        setDistributorDataNames(uniqueAgents);
      } else {
        ErrorToast(GetDistributorNames?.message);
      }
      setCheckAgentsName(false)
      // setLoading(false);
    }
  }, [GetDistributorNames])

  useEffect(() => {
    if (EditDistributor) {
      if (EditDistributor?.status === 200 && EditDistributor?.success) {
      } else {
        ErrorToast(EditDistributor?.message || 'Failed to update distributor');
      }
    }
  }, [EditDistributor])



  const AgentSummaryCard = ({ percent, name, label, color }) => {
    const radius = 30;
    const stroke = 6;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (percent / 100) * circumference;

    return (
      <div className="flex items-center space-x-3 border rounded-xl px-4 py-3 shadow-sm bg-white">
        <svg height={radius * 2} width={radius * 2}>
          <circle
            stroke="#e5e7eb"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke={color}
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference + ' ' + circumference}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            transform={`rotate(-90 ${radius} ${radius})`}
          />
          <text
            x="50%"
            y="50%"
            dy="0.3em"
            textAnchor="middle"
            className="text-sm font-semibold"
          >
            {percent}%
          </text>
        </svg>
        <div>
          <h4 className="font-semibold text-gray-800">{name}</h4>
          <p className="text-sm text-gray-500">{label}</p>
        </div>
      </div>
    );
  };

  // const StatusBadge = ({ status }) => (
  //   <span className={`text-sm font-medium ${status === 'Active' ? 'text-green-600' : 'text-red-600'}`}>
  //     {status}
  //   </span>
  // );

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status) {

      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Active</span>;
    } else {

      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Deactive</span>;
    }
    // if (status === "Deactive")
  };

  const tableColumns = [
    {
      label: "Name",
      render: (agent) => (
        <div className="flex flex-col items-start">
          <button
            className="cursor-pointer text-blue-600 font-medium text-left hover:underline"
            onClick={() => handleAgentClick(agent)}
          >
            {agent.username}
          </button>
          {agent.email && (
            <span className="text-xs text-gray-500 mt-0.5">
              {agent.email}
            </span>
          )}
        </div>
      ),
    },
    { label: "Mobile Number", key: "mobileNo" },
    {
      label: "Created Date",
      render: (agent) => agent.createdAt ? moment(agent.createdAt).format("DD MMMM, YYYY") : "N/A"
    },
    { label: "Created By", render: (agent) => agent.createdByAdminName || "N/A" },
    {
      label: "Status",

      render: (agent, _) => <StatusBadge status={agent.isActive} />
    },

    { label: "Assigned FASTag", render: (agent) => agent.assigned || "0", },
    { label: "Activated FASTag", render: (agent) => agent.activated || "0", },
    {
      label: "Show Dealer",
      render: (distributor) => (
        <button
          className="text-blue-600 font-medium underline cursor-pointer"
          onClick={() => {
            setSelectedDistributorForDealers(distributor);
            setShowDealersModal(true);
          }}
        >
          View Dealers
        </button>
      ),
    },
    {
      label: "Show Agent",
      render: (distributor) => (
        <button
          className="text-blue-600 font-medium underline cursor-pointer"
          onClick={() => {
            setSelectedDistributorForAgents(distributor);
            dispatch(ACTIONS.GetAgentsDistributorWiseAction({ distributorId: distributor._id }));
            setShowAgentsModal(true);
          }}
        >
          View Agents
        </button>
      ),
    },
    // { label: "Status", key: "status" },

    {
      label: "Action",
      key: "assign",
      tdClassName: 'flex justify-end',
      render: (agent) => (
        <div className='flex gap-3 items-center'>
          <div
            className='bg-[#EE3B311A] rounded-full w-[30px] h-[30px] flex items-center justify-center cursor-pointer'
            onClick={() => {
              setEditingDistributor(agent);   // Pass full data
              setShow1(true);
            }}
          >
            <img src={edit} alt="edit" className="w-[15px] h-[15px]" />
          </div>
        </div>
      ),
    }


  ];


  const handleDownload = () => {
    //Download pdf of the slected class's pdf file

    const link = document.createElement('a');
    link.href = vehicleClasses[0].pdf;
    link.download = 'vehicle_class.pdf'; // Optional: file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  return (
    <>
      <div className="p-0 space-y-8">
        {/* Agents Summary */}
        <div className="">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-800 mb-[16px] mt-[27.5px] ">Distributor</h2>
          </div>

          {/* Search and Filter */}
          <div className="flex justify-between items-center mt-6 mb-6 md:gap-10 gap-6  relative lg:flex-row flex-col">
            <div className="flex !w-full items-center gap-2 md:flex-row flex-col">
              {/* Serial Number Input with Search Icon */}
              <div className="relative md:w-60 w-full ">
                <TextInput
                  name="serialNumber"
                  placeholder="Mobile Number"
                  value={serialNumber}
                  onChange={(e) => setSerialNumber(e.target.value)}
                  inputClass="pl-5 pr-3 py-[12.5px] text-sm"
                />
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <Search className="w-4 h-4" />
                </div>
              </div>

              {/* Agent Dropdown using CustomSelectInput */}
              <div className="md:w-60 w-full">
                <CustomSelectInput
                  name="selectedAgent"
                  label="" // No label for inline layout
                  value={selectedAgent}
                  onChange={(e) => setSelectedAgent(e.target.value)}
                  options={[
                    { name: "All Distributors", value: "" },
                    ...distributorDataNames.map((agent) => ({ name: agent.username, value: agent?.username })),
                  ]}
                  inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                />
              </div>
            </div>


            {/* Add Button with Dropdown */}
            <div className="relative">
              <Button
                label="Add Distributor +"
                // onClick={() => setAddMenuOpen(!addMenuOpen)}
                onClick={() => setShow(true)}
                roundedButton
                className="!bg-green-500 hover:bg-green-600 text-white py-[11px] rounded-full px-[25px] font-medium text-sm"
              />
              {/* {addMenuOpen && (
              <div className="absolute right-0 mt-2 w-36 bg-white border rounded shadow z-10">
                <button
                  onClick={() => { setAddMenuOpen(false); setAddAgentsOpen(true); }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm border border-gray-200"
                >
                  Add New Agent
                  </button>
                <button
                  onClick={() => { setAddMenuOpen(false); setAddBulkAgentsOpen(true); }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                >
                  Add Bulk Agents
                </button>
              </div>
            )} */}
            </div>
          </div>
          {/* Agent Table */}

          <CommonTable
            columns={tableColumns}
            data={distributorData}
            emptyMessage="No Distributors Found"
            isPagination={true}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedDate={selectedDate}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
            setSelectedDate={setSelectedDate}
            tableData={tableData}
            total={GetDistributor?.data?.pagination?.total}
            totalPages={GetDistributor?.data?.pagination?.totalPages}
            loading={checkAgents}
            hideDateAndDownload={true}
          />

        </div>


        {/* Modals */}
        {show && <AddAgent title='Add Distributor' modalOpen={show} api='CreateDistributor' setModalOpen={setShow} onClose={() => { setShow(false); getData() }} />}
        {show1 && editingDistributor && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[500px]">
              <h2 className="text-xl font-semibold mb-4 borde flex justify-between">Edit Distributor</h2>

              {/* Read-only fields */}
              <div className="space-y-3">
                <div>
                  <label className="block text-sm">Username</label>
                  <input
                    type="text"
                    value={editingDistributor.username || ''}
                    onChange={(e) =>
                      setEditingDistributor({ ...editingDistributor, username: e.target.value })
                    }
                    placeholder="Enter username"
                    className="w-full border rounded px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>

                <div>
                  <label className="block text-sm">Mobile</label>
                  <input
                    type="text"
                    value={editingDistributor.mobileNo}
                    readOnly
                    disabled
                    className="w-full border rounded px-3 py-2 bg-gray-100 cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="block text-sm">Assigned FASTag</label>
                  <input
                    type="text"
                    value={editingDistributor.assigned || 0}
                    readOnly
                    disabled
                    className="w-full border rounded px-3 py-2 bg-gray-100 cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="block text-sm">Activated FASTag</label>
                  <input
                    type="text"
                    value={editingDistributor.activated || 0}
                    readOnly
                    disabled
                    className="w-full border rounded px-3 py-2 bg-gray-100 cursor-not-allowed"
                  />
                </div>

                {/* Editable Status */}
                <div>
                  <label className="block text-sm font-medium mb-1">Status</label>
                  <select
                    value={editingDistributor.isActive.toString()}
                    onChange={(e) =>
                      setEditingDistributor({ ...editingDistributor, isActive: e.target.value === 'true' })
                    }
                    className={`w-full border rounded px-3 py-2 appearance-none ${editingDistributor.isActive === false ? 'bg-red-100 text-red-700' : 'bg-white'
                      }`}
                  >
                    <option value="true">Active</option>
                    <option value="false">Deactive</option>
                  </select>
                </div>

                {/* Editable Email */}
                <div>
                  <label className="block text-sm font-medium mb-1">Email</label>
                  <input
                    type="email"
                    value={editingDistributor.email || ''}
                    onChange={(e) =>
                      setEditingDistributor({ ...editingDistributor, email: e.target.value })
                    }
                    placeholder="Enter email address"
                    className="w-full border rounded px-3 py-2 bg-white"
                  />
                </div>

                {/*
                FASTag Activation permission
                <div className="flex items-center justify-between border border-gray-200 rounded px-3 py-2">
                  <div>
                    <p className="text-sm font-medium text-gray-800">FASTag Activation</p>
                    <p className="text-xs text-gray-500">Allow this distributor to activate FASTags</p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={editingDistributor.canActivateFastag !== false}
                    onClick={() =>
                      setEditingDistributor({ ...editingDistributor, canActivateFastag: editingDistributor.canActivateFastag === false })
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${editingDistributor.canActivateFastag !== false ? 'bg-green-500' : 'bg-gray-300'}`}
                  >
                    <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${editingDistributor.canActivateFastag !== false ? 'translate-x-5' : 'translate-x-1'}`} />
                  </button>
                </div>
                */}

                {/* View Transactions permission */}
                <div className="flex items-center justify-between border border-gray-200 rounded px-3 py-2">
                  <div>
                    <p className="text-sm font-medium text-gray-800">View Transactions</p>
                    <p className="text-xs text-gray-500">Allow this distributor to view activated FASTag transactions</p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={editingDistributor.canViewTransactions !== false}
                    onClick={() =>
                      setEditingDistributor({ ...editingDistributor, canViewTransactions: editingDistributor.canViewTransactions === false })
                    }
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${editingDistributor.canViewTransactions !== false ? 'bg-green-500' : 'bg-gray-300'}`}
                  >
                    <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${editingDistributor.canViewTransactions !== false ? 'translate-x-5' : 'translate-x-1'}`} />
                  </button>
                </div>

              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => {
                    setShow1(false);
                    setEditingDistributor(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-red-500 text-white rounded"
                  onClick={async () => {
                    try {
                      if (!editingDistributor.username || editingDistributor.username.trim() === '') {
                        ErrorToast('Please enter a username');
                        return;
                      }
                      // Call Edit Distributor API
                      const params = {
                        username: editingDistributor.username.trim(),
                        isActive: editingDistributor.isActive,
                        email: editingDistributor.email || '',
                        // canActivateFastag: editingDistributor.canActivateFastag !== false,
                        canViewTransactions: editingDistributor.canViewTransactions !== false
                      };

                      dispatch(ACTIONS.EditDistributorAction(editingDistributor._id, params));

                      setShow1(false);
                      setEditingDistributor(null);
                      getData(); // refresh the table
                    } catch (error) {
                      console.error('Error updating distributor:', error);
                      ErrorToast('Failed to update distributor');
                    }
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}



        {addBulkAgentsOpen && <AddBulkAgents onClose={() => { setAddBulkAgentsOpen(false); getData() }} />}
        {
          agentModalOpen &&
          <AgentDetails title="Distributor Details" agent={selectedAgentClick} onBack={() => { setAgentModalOpen(false); getData() }} />
        }
        {showAgentsModal && selectedDistributorForAgents && (
          <DistributorAgentsModal
            distributor={selectedDistributorForAgents}
            onClose={() => {
              setShowAgentsModal(false);
              setSelectedDistributorForAgents(null);
            }}
            setModalOpen={setShowAgentsModal}
          />
        )}
        {showDealersModal && selectedDistributorForDealers && (
          <DistributorDealersModal
            distributor={selectedDistributorForDealers}
            onClose={() => {
              setShowDealersModal(false);
              setSelectedDistributorForDealers(null);
            }}
            setModalOpen={setShowDealersModal}
          />
        )}
      </div>
      {/* {show && <AddBulkAgents sidebarTitle="Upload Inventory" />} */}
    </>
  );
};

export default DistributorAdmin;